"use strict";

/**
 * Shared helpers used across multiple concat scripts. All concat files are
 * combined into one script, so these are available globally to the others.
 */
/* exported prefersReducedMotion, observeHeightProperty */

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Keeps a CSS custom property on <html> set to an element's current height.
 * Returns the ResizeObserver so callers can disconnect it.
 */
function observeHeightProperty(element, property) {
  const observer = new ResizeObserver(() => {
    document.documentElement.style.setProperty(property, `${element.offsetHeight}px`);
  });
  observer.observe(element);
  return observer;
}
"use strict";

/* global Munchkin */

(function () {
  /* Marketo Munchkin */
  (function () {
    var didInit = false;
    function initMunchkin() {
      if (didInit === false) {
        didInit = true;
        Munchkin.init('811-SJQ-803');
      }
    }
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function () {
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        initMunchkin();
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
  })();

  // Added Navattic tracking code
  // Queues navattic.<method>(...) calls until the SDK loads and replays them
  if (window.navatticQueue === undefined) {
    window.navatticQueue = [];
    window.navattic = new Proxy({}, {
      get: function (target, method) {
        return function () {
          return window.navatticQueue.push({
            function: method,
            arguments: Array.prototype.slice.call(arguments)
          });
        };
      }
    });
  }
  var navatticScript = document.createElement('script');
  navatticScript.async = true;
  navatticScript.src = 'https://js.navattic.com/sdk.js?key=pkey_cm34l18l4032lrs3bg46i4hfe';
  document.getElementsByTagName('head')[0].appendChild(navatticScript);
})();
"use strict";

/* global prefersReducedMotion */

/**
 * Shared open/close height animation for accordion-style elements.
 * Cancelling a running animation reassigns `this.animation` synchronously
 * (see `animateHeight`), so `oncancel` handlers should not touch it.
 */
class HeightAnimator {
  constructor(element) {
    this.element = element;
    this.animation = null;
  }
  animateHeight(startHeight, endHeight, {
    onFinish,
    onCancel
  } = {}) {
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.element.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => {
      this.animation = null;
      onFinish?.();
    };
    this.animation.oncancel = () => onCancel?.();
  }
}

/**
 * Animates core/detail's open/close height.
 */
class DetailsAccordion extends HeightAnimator {
  constructor(details) {
    super(details);
    this.details = details;
    this.summary = details.querySelector(':scope > summary');
    this.isClosing = false;
    this.isExpanding = false;
    if (this.summary) {
      this.summary.addEventListener('click', this.onClick.bind(this));
    }
  }
  onClick(event) {
    if (prefersReducedMotion()) {
      return;
    }
    event.preventDefault();
    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }
  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.details.scrollHeight}px`;
    this.animateHeight(startHeight, endHeight, {
      onFinish: () => this.onAnimationFinish(true),
      onCancel: () => this.onAnimationCancel()
    });
  }
  shrink() {
    this.isClosing = true;
    const style = window.getComputedStyle(this.details);
    const verticalPadding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + verticalPadding}px`;
    this.animateHeight(startHeight, endHeight, {
      onFinish: () => this.onAnimationFinish(false),
      onCancel: () => this.onAnimationCancel()
    });
  }
  onAnimationFinish(open) {
    this.details.open = open;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  }
  onAnimationCancel() {
    this.isClosing = false;
    this.isExpanding = false;
  }
}
document.querySelectorAll('.wp-block-details').forEach(details => {
  new DetailsAccordion(details);
});

/**
 * Animates core/accordion's open/close height.
 */
class AccordionPanel extends HeightAnimator {
  constructor(panel) {
    super(panel);
    this.panel = panel;
    this.toggle = panel.closest('.wp-block-accordion-item')?.querySelector('.wp-block-accordion-heading__toggle');
    this.openHeight = null;
    if (this.toggle) {
      document.addEventListener('click', event => {
        if (this.toggle.contains(event.target)) {
          this.openHeight = `${this.panel.scrollHeight}px`;
        }
      }, true);
    }
    this.observer = new MutationObserver(() => this.onToggle());
    this.observer.observe(panel, {
      attributes: true,
      attributeFilter: ['inert']
    });
  }
  onToggle() {
    if (prefersReducedMotion()) {
      return;
    }
    if (this.panel.inert) {
      this.shrink();
    } else {
      this.expand();
    }
  }
  expand() {
    const endHeight = `${this.panel.scrollHeight}px`;
    this.runAnimation('0px', endHeight);
  }
  shrink() {
    const startHeight = this.openHeight ?? `${this.panel.scrollHeight}px`;
    this.runAnimation(startHeight, '0px');
  }
  runAnimation(startHeight, endHeight) {
    this.panel.style.overflow = 'hidden';
    this.animateHeight(startHeight, endHeight, {
      onFinish: () => {
        this.panel.style.overflow = '';
      }
    });
  }
}
document.querySelectorAll('.wp-block-accordion-panel').forEach(panel => {
  new AccordionPanel(panel);
});

// Exposed so FAQ markup or blocks rendered after this script runs (e.g. the Gutenberg block editor's iframed preview) can be re-instantiated.
window.DetailsAccordion = DetailsAccordion;
window.AccordionPanel = AccordionPanel;
"use strict";

/**
 * Collapses and removes the announcement bar when its close button is clicked.
 * Relies on HeightAnimator from accordion.js, and prefersReducedMotion
 * from 00_utilities.js.
 */
/* global HeightAnimator, prefersReducedMotion */
class AnnouncementBar extends HeightAnimator {
  // Also read by the inline script in header.php to hide the bar before first paint.
  static storageKey = 'vts-announcement-dismissed';
  bar = null;
  closeButton = null;
  resizeObserver = null;
  constructor(element) {
    super(element);
    this.grabElements(element);
    if (this.isDismissed()) {
      this.removeBar();
      return;
    }
    if (this.validateElements()) {
      this.bindEvents();
    }
  }
  grabElements(element) {
    this.bar = element;
    this.closeButton = this.bar.querySelector('#announcement-close');
  }
  validateElements() {
    let isValid = true;
    if (!this.closeButton) {
      console.error('No close button found for announcement bar', this.bar);
      isValid = false;
    }
    return isValid;
  }
  bindEvents() {
    this.closeButton.addEventListener('click', this.closeBar.bind(this));
  }
  isDismissed() {
    try {
      return window.sessionStorage.getItem(AnnouncementBar.storageKey) === 'true';
    } catch {
      return false;
    }
  }
  saveDismissed() {
    try {
      window.sessionStorage.setItem(AnnouncementBar.storageKey, 'true');
    } catch {
      // Storage unavailable (e.g. private mode); bar will reappear next page.
    }
  }
  closeBar() {
    this.saveDismissed();
    if (prefersReducedMotion()) {
      this.removeBar();
      this.refreshScrollTriggers();
      return;
    }
    this.closeButton.disabled = true;
    this.bar.style.overflow = 'hidden';
    this.animateHeight(`${this.bar.offsetHeight}px`, '0px', {
      onFinish: () => {
        this.removeBar();
        this.refreshScrollTriggers();
      }
    });
  }

  // Removing the bar shifts the sticky header, so recalculate trigger positions that offset by it.
  refreshScrollTriggers() {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  }
  removeBar() {
    this.bar.remove();
  }
}
document.querySelectorAll('.page-wrapper__alert').forEach(element => {
  new AnnouncementBar(element);
});
"use strict";

/* global prefersReducedMotion */

/**
 * Logo swap grid built on Swiper Element.
 * Each column is a vertical <swiper-container> with autoplay off. One master
 * timer calls slideNext() on every column, staggered left to right, so the
 * wave never drifts out of sync the way six separate autoplay timers would.
 *
 * Under prefers-reduced-motion the columns fade instead of slide, and the
 * rotation stops for good after data-max-cycles swaps.
 */
class FlipCarousel {
  static getSwiperParams() {
    const base = {
      direction: 'vertical',
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: false,
      keyboard: false
    };
    if (prefersReducedMotion()) {
      return {
        ...base,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        }
      };
    }
    return {
      ...base,
      effect: 'creative',
      creativeEffect: {
        prev: {
          translate: [0, '-45%', 0],
          opacity: 0
        },
        next: {
          translate: [0, '45%', 0],
          opacity: 0
        }
      }
    };
  }
  constructor(grid) {
    this.grid = grid;
    this.interval = Number(grid.dataset.interval) || 3000;
    this.stagger = Number(grid.dataset.stagger) || 120;
    this.timer = null;
    this.isVisible = false;
    // Only reduced motion caps the rotation; otherwise it runs indefinitely
    this.maxCycles = prefersReducedMotion() ? Number(grid.dataset.maxCycles) || 3 : Infinity;
    this.cycles = 0;
    this.cells = [];
    this.cellCount = null;
    this.logos = this.collectLogos();
    this.build();
    this.onIntersect = this.onIntersect.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onResize = this.onResize.bind(this);
    this.observer = new IntersectionObserver(this.onIntersect);
    this.observer.observe(grid);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    window.addEventListener('resize', this.onResize);
  }

  /**
   * Clones every server-rendered slide back into its original logo order.
   * PHP deals logos round-robin into columns, so reading row by row across
   * the columns undoes that.
   */
  collectLogos() {
    const columns = [...this.grid.querySelectorAll('swiper-container')].map(el => [...el.querySelectorAll('swiper-slide')]);
    const rows = Math.max(0, ...columns.map(slides => slides.length));
    const logos = [];
    for (let row = 0; row < rows; row++) {
      columns.forEach(slides => {
        if (slides[row]) {
          logos.push(slides[row].cloneNode(true));
        }
      });
    }
    return logos;
  }

  /**
   * Number of visible cells for the current breakpoint, set in CSS via
   * --flip-cells (8 on mobile as 2 rows of 4, 6 on tablet, 7 on desktop).
   */
  getCellCount() {
    const value = getComputedStyle(this.grid).getPropertyValue('--flip-cells');
    return parseInt(value, 10) || 7;
  }

  /**
   * Deals the logos into one vertical swiper per cell and initializes them.
   */
  build() {
    const count = this.getCellCount();
    if (count === this.cellCount) {
      return;
    }
    this.cells.forEach(({
      el
    }) => el.swiper?.destroy(true, true));
    this.cellCount = count;
    const buckets = Array.from({
      length: count
    }, () => []);
    this.getPool(count).forEach((logo, index) => {
      const slide = logo.cloneNode(true);

      // Padding repeats are visual filler; keep each customer to one mention
      if (index >= this.logos.length) {
        slide.setAttribute('aria-hidden', 'true');
      }
      buckets[index % count].push(slide);
    });
    const containers = buckets.filter(slides => slides.length).map(slides => {
      const el = document.createElement('swiper-container');
      // Must be set before the element connects or it self-initializes
      el.setAttribute('init', 'false');
      el.className = 'customers-flip-carousel__cell';
      el.append(...slides);
      return el;
    });
    this.grid.replaceChildren(...containers);
    this.cells = this.initCells();
  }

  /**
   * Repeats the logo list until every cell gets at least two slides and
   * every cell gets the same number, so all cells rotate and the rows stay
   * aligned. Dealing consecutive logos across a row keeps duplicates out
   * of view at the same time whenever there are at least as many logos as
   * cells.
   *
   * With at least two rows of logos, the last row is padded from the second
   * row rather than the first. As the wave loops back, the first row flips
   * in while the last row is still showing, and padding from the second row
   * starts in an earlier column than it did there, so no logo appears twice
   * mid-wave. With fewer logos the first row is the only source, and a brief
   * repeat during the loop-back can't be avoided.
   */
  getPool(count) {
    const total = this.logos.length;
    if (!total) {
      return [];
    }
    const length = Math.ceil(Math.max(total, count * 2) / count) * count;
    const padding = total >= count * 2 ? this.logos.slice(count) : this.logos;
    return [...this.logos, ...Array.from({
      length: length - total
    }, (_, index) => padding[index % padding.length])];
  }
  initCells() {
    const params = FlipCarousel.getSwiperParams();
    return [...this.grid.querySelectorAll('swiper-container')].map(el => {
      const count = el.querySelectorAll('swiper-slide').length;

      // loop needs 2+ slides; a single-logo column just sits still
      Object.assign(el, {
        ...params,
        loop: count > 1
      });
      el.initialize();
      return {
        el,
        count
      };
    });
  }
  tick() {
    this.cells.forEach(({
      el,
      count
    }, index) => {
      if (count < 2) {
        return;
      }
      setTimeout(() => el.swiper?.slideNext(), index * this.stagger);
    });
    this.cycles++;
    if (this.cycles >= this.maxCycles) {
      this.stop();
    }
  }
  start() {
    if (this.timer || this.cycles >= this.maxCycles || !this.isVisible || document.hidden) {
      return;
    }
    this.timer = setInterval(() => this.tick(), this.interval);
  }
  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }
  onIntersect([entry]) {
    this.isVisible = entry.isIntersecting;
    if (this.isVisible) {
      this.start();
    } else {
      this.stop();
    }
  }
  onResize() {
    if (this.getCellCount() === this.cellCount) {
      return;
    }
    const wasRunning = Boolean(this.timer);
    this.stop();
    this.build();
    if (wasRunning) {
      this.start();
    }
  }
  onVisibilityChange() {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  }

  /**
   * Tears down timers, observers and Swiper instances, e.g. before the
   * block editor re-renders the preview.
   */
  destroy() {
    this.stop();
    this.observer.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    window.removeEventListener('resize', this.onResize);
    this.cells.forEach(({
      el
    }) => el.swiper?.destroy(true, true));
    delete this.grid.flipCarousel;
  }
}
function initFlipCarousels(root = document) {
  root.querySelectorAll('.customers-flip-carousel').forEach(grid => {
    // Guard against double init when re-instantiating (e.g. editor preview)
    if (!grid.flipCarousel) {
      grid.flipCarousel = new FlipCarousel(grid);
    }
  });
}
initFlipCarousels();

// Exposed so grids rendered after this script runs (e.g. the Gutenberg block editor's iframed preview) can be re-instantiated.
window.flipCarousel = FlipCarousel;
window.initFlipCarousels = initFlipCarousels;
"use strict";

/**
 * Exposes the sticky header's height as --header-height so sticky content can sit below it.
 */
/* global observeHeightProperty */
document.querySelectorAll('.page-wrapper__header').forEach(header => {
  observeHeightProperty(header, '--header-height');
});
"use strict";

// Force a repaint when each lazysizes image finishes loading
document.addEventListener('lazyloaded', function (e) {
  const img = e.target.tagName === 'IMG' ? e.target : e.target.querySelector('img');
  if (!img) return;
  const kick = () => {
    img.style.transform = 'translateZ(0)';
    requestAnimationFrame(() => {
      img.style.transform = '';
    });
  };
  img.complete ? kick() : img.addEventListener('load', kick, {
    once: true
  });
});
"use strict";

/* global MARKETO_ARGS */

let marketoScript = null;
const formQueues = new Map();

// Injects forms2.min.js once, the first time a form on the page needs it
function loadMarketoScript(baseUrl) {
  if (window.MktoForms2) {
    return Promise.resolve();
  }
  if (!marketoScript) {
    marketoScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `${baseUrl.replace(/\/$/, '')}/js/forms2/js/forms2.min.js`;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Failed to load ${script.src}`));
      document.head.append(script);
    });
  }
  return marketoScript;
}

/**
 * Loads a Marketo Form onto the page.
 * Usage: <div class="vts-marketo-form" data-form-id="{YOUR_MARKETO_FORM_ID}"></div>
 *
 * On success, dispatches a bubbling, cancelable `vts:marketo-success` event from the container
 * with detail { form, formId, values, followUpUrl }.
 */
class MarketoForm {
  constructor(el) {
    this.container = el;
    this.formId = el.dataset.formId;
    const {
      baseUrl,
      munchkinId
    } = MARKETO_ARGS; // Set in the general theme options page and loaded with wp_add_inline_script

    if (baseUrl && munchkinId && this.formId) {
      this.loadForm(baseUrl, munchkinId);
    }
  }
  loadForm(baseUrl, munchkinId) {
    const formEl = document.createElement('form');
    this.container.appendChild(formEl);
    const previousLoad = formQueues.get(this.formId) || Promise.resolve();
    const load = previousLoad.then(() => loadMarketoScript(baseUrl)).then(() => new Promise(resolve => {
      // MktoForms2 renders into the first element with this id, so same-ID forms load one at a time and drop the id once rendered
      formEl.id = `mktoForm_${this.formId}`;
      window.MktoForms2.loadForm(baseUrl, munchkinId, this.formId, form => {
        formEl.removeAttribute('id');
        this.bindSuccess(form);
        resolve();
      });
    }));
    formQueues.set(this.formId, load.catch(() => {}));
    load.catch(error => console.warn('Marketo form failed to load', error));
  }
  bindSuccess(form) {
    form.onSuccess((values, followUpUrl) => {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'marketo_form_submission',
        formID: this.formId
      });

      // Per-form actions listen for this; preventDefault() stops Marketo's follow-up redirect
      const event = new CustomEvent('vts:marketo-success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form,
          formId: this.formId,
          values,
          followUpUrl
        }
      });
      const proceed = this.container.dispatchEvent(event);
      return proceed ? undefined : false;
    });
  }
}
document.querySelectorAll('.vts-marketo-form').forEach(el => {
  new MarketoForm(el);
});
"use strict";

/**
 * mobile-menu.js
 *
 * Handles toggling the mobile menu and subnav pages
 */

class MobileMenu {
  constructor() {
    this.elements = null;
    this.grabElements();
    if (this.elements.navigation.length) {
      this.bindEvents();
    }
  }
  grabElements() {
    this.elements = {
      body: jQuery('body'),
      menuTrigger: jQuery('.js-toggle-menu'),
      navigation: jQuery('.site-header__navigation'),
      subMenuToggle: jQuery('.js-submenu-trigger'),
      window: jQuery(window)
    };
  }
  bindEvents() {
    this.elements.menuTrigger.on('click', this.handleToggleMenu.bind(this));
    this.elements.body.on('keydown', this.mobileKeyboardNavigation.bind(this));
    this.elements.window.on('load resize', this.addMobileAttrs.bind(this));
  }
  addMobileAttrs() {
    this.elements.navigation.attr('aria-hidden', this.elements.window.width() < 1024 && !this.elements.navigation.hasClass('mobile-open'));
  }
  toggleMobileAttrs() {
    this.elements.navigation.toggleClass('mobile-open');
    this.elements.menuTrigger.toggleClass('mobile-open');
    this.elements.menuTrigger.attr('aria-expanded', (_, attr) => !(attr === 'true'));
    this.elements.navigation.attr('aria-hidden', (_, attr) => !(attr === 'true'));
  }
  mobileKeyboardNavigation(e) {
    if (this.elements.navigation.hasClass('mobile-open')) {
      if (e.key === 'Escape') {
        // Close mobile menu and focus trigger
        this.toggleMobileAttrs();
        // eslint-disable-next-line no-undef
        bodyScrollLock.enableBodyScroll(this.elements.navigation);
        setTimeout(() => this.elements.menuTrigger.trigger('focus'), 200);
      } else if (e.key === 'Tab') {
        // Handle mobile keyboard navigation, keeping user confined to menu and trigger
        const allNavLinks = this.elements.navigation.find('a, button');
        const firstNavLink = allNavLinks[0];
        if (!e.shiftKey) {
          if (document.activeElement === this.elements.menuTrigger[0]) {
            e.preventDefault();
            jQuery(firstNavLink).trigger('focus');
          }
        } else if (e.shiftKey) {
          if (document.activeElement === firstNavLink) {
            e.preventDefault();
            this.elements.menuTrigger.trigger('focus');
          }
        }
      }
    }
  }
  handleToggleMenu() {
    this.toggleMobileAttrs();
    if (this.elements.navigation.hasClass('mobile-open')) {
      // eslint-disable-next-line no-undef
      bodyScrollLock.disableBodyScroll(this.elements.navigation, {
        allowTouchMove: () => true
      });

      // Focus first link on menu open
      const firstNavEl = jQuery(this.elements.navigation.find('a, button').first());
      setTimeout(() => firstNavEl.trigger('focus'), 200);
    } else {
      window.subMenuNav.closeAllSubmenu();
      bodyScrollLock.enableBodyScroll(this.elements.navigation); // eslint-disable-line no-undef
    }
  }
}
jQuery(document).ready(() => {
  window.mobileMenu = new MobileMenu();
});
"use strict";

class VTSModal {
  modal = null;
  modalId = '';
  trigger = null;
  closeButton = null;
  constructor(element) {
    this.grabElements(element);
    if (this.validateElements()) {
      // ScrollTrigger pins move child content out of the DOM momentarily on window resize,
      // which causes the modal to drop out of the top layer and appear underneath page content
      // when it's put back. Move all modals to the end of the body to avoid this.
      this.modal.ownerDocument.body.append(this.modal);
      this.bindEvents();
    }
  }
  grabElements(element) {
    this.modal = element;
    this.modalId = this.modal.id;
    this.trigger = document.getElementById(`${this.modalId}-trigger`);
    this.closeButton = this.modal.querySelector('.vts-base-modal__close');
  }
  validateElements() {
    let isValid = true;
    if (this.modal.tagName.toLowerCase() !== 'dialog') {
      console.error('Modal must be a dialog element', this.modal);
      isValid = false;
    }
    if (!this.modalId) {
      console.error('Modal ID must be present', this.modal);
      isValid = false;
    }
    const modalLabel = this.modal.getAttribute('aria-labelledby');
    if (!modalLabel || !document.getElementById(modalLabel)) {
      console.error('Modal label must be present', this.modal);
      isValid = false;
    }
    if (!this.trigger) {
      console.error('No trigger found for modal element', this.modal);
      isValid = false;
    }
    if (this.trigger && this.trigger.tagName.toLowerCase() !== 'button') {
      console.error('Trigger must be a button', this.trigger);
      isValid = false;
    }
    return isValid;
  }
  bindEvents() {
    this.trigger.addEventListener('click', this.openModal.bind(this));
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    // Fires for close() and for the native Escape dismissal
    this.modal.addEventListener('close', this.onClose.bind(this));
  }
  openModal() {
    this.modal.classList.add('open');
    this.trigger.classList.add('open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.modal.showModal();
  }
  closeModal() {
    this.modal.close();
  }
  onClose() {
    this.modal.classList.remove('open');
    this.trigger.classList.remove('open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.focus();
  }
}
document.querySelectorAll('.vts-base-modal').forEach(element => {
  new VTSModal(element);
});

// Exposed so blocks can re-instantiate modals rendered outside the main
// document flow, e.g. inside the Gutenberg block editor preview iframe.
window.VTSModal = VTSModal;
"use strict";

/**
 * Pinned horizontal card scroll, shared by the Scrolling Product Cards and Image Cards blocks.
 * Page scroll slides an overflowing row of cards across until the last card meets the content edge, either pinning the
 * block while it does or (with no pin) as the block scrolls past. The row scrolls natively in CSS until this takes
 * over, and for reduced motion.
 * GSAP and ScrollTrigger are dependencies of the main project JS (see vts_2027_register_gsap()).
 */
class VTSPinnedCardScroll {
  /**
   * @param {HTMLElement} element The block's section.
   * @param {Object} options
   * @param {HTMLElement} options.row The overflowing row.
   * @param {HTMLElement[]} options.cards
   * @param {HTMLElement} options.viewport The element whose width the cards scroll through.
   * @param {HTMLElement|false} options.pin False to scrub the row without pinning, so no pin-spacer is added.
   * @param {HTMLElement} [options.pinSpacer] An existing parent of the pin to use as ScrollTrigger's pin spacer.
   *     Without one, the pin is moved into a generated spacer on every refresh, which reloads embeds like Wistia
   *     players.
   * @param {HTMLElement} options.trigger
   * @param {string|Function} options.start ScrollTrigger start. A function is re-evaluated on each refresh.
   * @param {string|Function} [options.end] ScrollTrigger end. Defaults to the scroll distance past the start, which
   *     suits a pin; set it when not pinning, so the row finishes while the block is still in view.
   * @param {string[]} options.media Queries to animate at. Each is set up separately, so the animation is rebuilt
   *     when crossing between them (where the cards change width).
   * @param {string} options.animatedClass Added to the row while animated, to drop its native scrolling.
   */
  constructor(element, options) {
    this.element = element;
    Object.assign(this, options);
    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();
    this.media.forEach(query => mm.add(`(prefers-reduced-motion: no-preference) and ${query}`, () => this.animate()));
    this.row.addEventListener('focusin', event => requestAnimationFrame(() => this.revealCard(event.target)));
  }
  getScrollDistance() {
    const first = this.cards[0];
    const last = this.cards[this.cards.length - 1];
    return last.offsetLeft + last.offsetWidth - first.offsetLeft - this.viewport.clientWidth;
  }
  animate() {
    // Cards that exactly fill the row don't need to scroll; allow for offset rounding.
    if (this.getScrollDistance() <= 1) {
      return;
    }
    this.row.classList.add(this.animatedClass);
    this.tween = gsap.to(this.row, {
      x: () => -this.getScrollDistance(),
      ease: 'none',
      scrollTrigger: {
        trigger: this.trigger,
        pin: this.pin,
        pinSpacer: this.pinSpacer,
        anticipatePin: this.pin ? 1 : 0,
        scrub: 1,
        start: this.start,
        end: this.end || (() => '+=' + this.getScrollDistance()),
        invalidateOnRefresh: true,
        refreshPriority: 0
      }
    });
    return () => {
      this.row.classList.remove(this.animatedClass);
      this.tween = null;
    };
  }

  // The animated row can't scroll, so a focused card past the edge is brought into view by scrolling the page to
  // the point in the animation where it's fully visible.
  revealCard(target) {
    const trigger = this.tween?.scrollTrigger;
    const card = this.cards.find(item => item.contains(target));
    if (!trigger || !card) {
      return;
    }
    const distance = this.getScrollDistance();
    const left = card.offsetLeft - this.cards[0].offsetLeft;
    const right = left + card.offsetWidth - this.viewport.clientWidth;
    const progress = gsap.utils.clamp(Math.max(0, right / distance), Math.min(1, left / distance), trigger.progress);
    if (progress !== trigger.progress) {
      window.scrollTo({
        top: trigger.start + progress * (trigger.end - trigger.start),
        behavior: 'instant'
      });
    }
  }
}
(() => {
  const blocks = {
    '.scrolling-product-cards': element => {
      const row = element.querySelector('.scrolling-product-cards__row--overflow');
      const trigger = element.querySelector('.scrolling-product-cards__inner');
      return row && {
        row,
        cards: [...row.querySelectorAll('.scrolling-product-cards__card')],
        viewport: element.querySelector('.scrolling-product-cards__cards'),
        // Pin a wrapper, not the section: pinning moves the pinned element's margins onto the pin spacer
        // and fixes its width, which would cancel the section's section--break-out margins.
        pin: element.closest('.scrolling-product-cards-pin'),
        pinSpacer: element.closest('.wp-block-acf-scrolling-product-cards'),
        trigger: trigger,
        // Above mobile, start once the trigger's top reaches the bottom of the sticky header. Measured
        // directly rather than via --header-height, which may not be set yet on the first refresh.
        start: () => window.matchMedia('(max-width: 766px)').matches ? 'bottom bottom-=150px' : `bottom bottom`,
        // The overflow cards change width at md, where the scroll distance can drop to 0.
        media: ['(max-width: 766px)', '(min-width: 767px)'],
        animatedClass: 'scrolling-product-cards__row--animated'
      };
    },
    '.image-cards': element => {
      const row = element.querySelector('.image-cards__cards-row');
      return row && {
        row,
        cards: [...row.children],
        viewport: element,
        // No pin: a pin-spacer leaves empty space around the pinned section and hides the next section
        // until the cards finish. Instead the cards slide across as the row scrolls up the viewport,
        // settling before it reaches the top.
        pin: false,
        trigger: row,
        start: 'top 60%',
        end: 'bottom 60%',
        // Tablet only: the cards wrap into a grid at the other sizes. Matches the tablet query in
        // block.scss.
        media: ['(min-width: 767px) and (max-width: 1023px)'],
        animatedClass: 'image-cards__cards-row--animated'
      };
    }
  };
  const instances = [];
  document.querySelectorAll(Object.keys(blocks).join(', ')).forEach(element => {
    const selector = Object.keys(blocks).find(key => element.matches(key));
    const options = blocks[selector](element);
    if (options) {
      instances.push(new VTSPinnedCardScroll(element, options));
    }
  });
  if (!instances.length) {
    return;
  }

  // ScrollTrigger only re-measures on load and resize, so content that changes the page height later (fonts,
  // Wistia players) would leave the pins' start and end stale.
  let height = document.body.offsetHeight;
  let timeout;
  new ResizeObserver(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (document.body.offsetHeight !== height) {
        ScrollTrigger.refresh();
        height = document.body.offsetHeight;
      }
    }, 100);
  }).observe(document.body);
})();
"use strict";

/**
 * Scroll Reveal heading (.is-style-scroll-reveal).
 * Layers a muted, aria-hidden copy of the heading over its gradient text, splits
 * the copy into words and fades each word to transparent as the heading scrolls
 * through the viewport, uncovering the gradient underneath.
 *
 * GSAP, ScrollTrigger and SplitText are dependencies of the main project JS
 * (see vts_2027_register_gsap()).
 */
class VTSScrollReveal {
  heading = null;
  overlayClass = 'is-style-scroll-reveal__overlay';
  wordClass = 'is-style-scroll-reveal__word';
  constructor(element) {
    this.heading = element;
    this.init();
  }
  init() {
    gsap.registerPlugin(ScrollTrigger, SplitText);
    gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => this.animate());
  }
  animate() {
    const overlay = this.createOverlay();
    const {
      words
    } = SplitText.create(overlay, {
      type: 'words',
      wordsClass: this.wordClass,
      aria: 'none'
    });
    if (!words.length) {
      overlay.remove();
      return;
    }
    gsap.to(words, {
      opacity: 0,
      ease: 'none',
      stagger: 0.1,
      scrollTrigger: {
        trigger: this.heading,
        start: 'top 85%',
        end: 'bottom 45%',
        scrub: true
      }
    });

    // Clean up when the media query stops matching.
    return () => overlay.remove();
  }
  createOverlay() {
    const overlay = document.createElement('span');
    overlay.className = this.overlayClass;
    overlay.setAttribute('aria-hidden', 'true');
    this.heading.childNodes.forEach(node => overlay.appendChild(node.cloneNode(true)));
    overlay.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
    this.heading.appendChild(overlay);
    return overlay;
  }
}
document.querySelectorAll('.is-style-scroll-reveal').forEach(element => new VTSScrollReveal(element));
"use strict";

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */

class SkipLinkFocusFix {
  constructor() {
    this.browsers = {
      isWebkit: navigator.userAgent.toLowerCase().indexOf('webkit') > -1,
      isOpera: navigator.userAgent.toLowerCase().indexOf('opera') > -1,
      isIe: navigator.userAgent.toLowerCase().indexOf('msie') > -1
    };
    this.bindEvents();
  }
  bindEvents() {
    if ((this.browsers.isWebkit || this.browsers.isOpera || this.browsers.isIe) && document.getElementById && window.addEventListener) {
      window.addEventListener('hashchange', () => {
        const id = window.location.hash.substring(1);
        if (!/^[A-z0-9_-]+$/.test(id)) {
          return;
        }
        const element = document.getElementById(id);
        if (element) {
          if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
          }
          element.focus();
        }
      }, false);
    }
  }
}
window.skipLinkFocusFix = new SkipLinkFocusFix();
"use strict";

/**
 * sub-menu-nav.js
 *
 * Handles toggling the sub menus
 */

class SubMenuNav {
  constructor() {
    this.elements = null;
    this.grabElements();
    if (this.elements.subMenuToggle.length) {
      this.bindEvents();
    }
  }
  grabElements() {
    this.elements = {
      window: jQuery(window),
      body: jQuery('body'),
      navigation: jQuery('.main-navigation'),
      subMenuToggle: jQuery('.js-submenu-trigger'),
      parent: jQuery('.menu-item-has-children'),
      subMenu: jQuery('.js-sub-menu')
    };
  }
  bindEvents() {
    this.elements.subMenuToggle.on('click', this.handleSubMenu.bind(this));
    this.elements.body.on('keyup', this.closeSubmenuOnEsc.bind(this));
  }
  updateAriaAttrs(trigger, submenu) {
    trigger.attr('aria-expanded', 'true');
    submenu.attr('aria-hidden', 'false');
  }
  handleSubMenu(e) {
    e.preventDefault();
    const target = jQuery(e.currentTarget);
    const parent = jQuery(target.closest(this.elements.parent));
    const submenu = jQuery(parent.find(this.elements.subMenu));
    if (parent.hasClass('active')) {
      this.closeAllSubmenu();
    } else {
      this.closeAllSubmenu();
      parent.addClass('active');
      this.elements.navigation.addClass('submenu-open');
      this.updateAriaAttrs(target, submenu);
    }
  }
  closeAllSubmenu() {
    this.elements.navigation.removeClass('submenu-open');
    this.elements.parent.removeClass('active');
    this.elements.subMenuToggle.attr('aria-expanded', 'false');
    this.elements.subMenu.attr('aria-hidden', 'true');
  }
  closeSubmenuOnEsc(e) {
    if (e.key === 'Escape' && this.elements.navigation.hasClass('submenu-open')) {
      this.closeAllSubmenu();
    }
  }
}
jQuery(document).ready(() => {
  window.subMenuNav = new SubMenuNav();
});
"use strict";

/* global prefersReducedMotion */
class AccessibleSwiperCarousel {
  constructor(element) {
    this.element = element;
    this.applyAccessibilityDefaults();
    this.element.initialize();
  }
  applyAccessibilityDefaults() {
    Object.assign(this.element, {
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });

    // Respect the user's OS-level reduced-motion preference regardless of
    // what autoplay/speed attributes are set on the <swiper-container>.
    if (prefersReducedMotion()) {
      Object.assign(this.element, {
        autoplay: false,
        speed: 0
      });
    }
  }
}

// Any <swiper-container> marked init="false" gets accessibility defaults
// applied here before Swiper initializes it. Author-set attributes (loop,
// slides-per-view, autoplay, etc.) are unaffected since they target different
// params than the ones set above.
document.querySelectorAll('swiper-container[init="false"]').forEach(element => new AccessibleSwiperCarousel(element));
"use strict";

/**
 * Playback options for the Wistia player component (see vts_2027_wistia_player()
 * in inc/components.php).
 *
 * - Autoplay is applied here rather than in markup so it can be skipped for
 *   visitors who prefer reduced motion.
 * - "play" and "none" control modes hide Wistia's UI and use a custom
 *   play/pause <button>, which gives keyboard users Space/Enter for free.
 *   In "play" mode, while playing, the button is only shown on hover or
 *   keyboard focus (always shown on touch devices).
 *   In "none" mode the button is only shown on keyboard focus or while paused.
 * - Hover play also responds to keyboard focus within the hover target.
 * - Hover and scroll only pause playback they started, and scroll won't
 *   restart a video the visitor paused.
 * - Any button with data-wistia-control="toggle|play|pause" and aria-controls
 *   set to the player id controls it (this includes the built-in button).
 */
/* global prefersReducedMotion */
class VTSWistiaPlayer {
  static instances = new Map();
  constructor(element) {
    this.element = element;
    this.player = element.querySelector('wistia-player');
    if (!this.player) {
      return;
    }

    // play() is silently dropped until Wistia's API is ready, not just once the
    // element is defined.
    this.ready = customElements.whenDefined('wistia-player').then(() => this.player.whenApiReady());
    // Which interaction started the current playback: 'hover', 'scroll',
    // or null for autoplay/an explicit play.
    this.playSource = null;
    this.userPaused = false;
    // Intended state: set immediately by play()/pause() so a quick
    // hover-out before Wistia's `play` event still pauses.
    this.playing = false;
    this.isHovered = false;
    this.isFocused = false;
    const reducedMotion = prefersReducedMotion();
    const shouldAutoplay = element.hasAttribute('data-wistia-autoplay') && !reducedMotion;
    if (shouldAutoplay) {
      this.player.setAttribute('autoplay', 'true');
    }
    customElements.whenDefined('wistia-player').then(() => this.inheritCursor());
    this.playing = shouldAutoplay;
    VTSWistiaPlayer.instances.set(this.player.id, this);
    this.bindEvents();
    this.setState(shouldAutoplay ? 'loading' : 'paused');
    if (element.hasAttribute('data-wistia-hover')) {
      this.bindHover();
    }
    if (element.hasAttribute('data-wistia-scroll') && !reducedMotion) {
      this.bindScroll();
    }
  }
  bindEvents() {
    this.player.addEventListener('play', () => {
      // Not requested by us, e.g. a click on the video or Wistia's controls.
      if (!this.playing) {
        this.playing = true;
        this.playSource = null;
        this.userPaused = false;
      }
      this.setState('playing');
    });
    const onStop = () => {
      if (this.playing) {
        this.playing = false;
        this.playSource = null;
        this.userPaused = true;
      }
      this.setState('paused');
    };
    this.player.addEventListener('pause', onStop);
    this.player.addEventListener('ended', onStop);
  }
  bindHover() {
    const selector = this.element.dataset.wistiaHover;
    const target = selector && this.element.closest(selector) || this.element;

    // Mouse and pen only; touch fires pointerenter on tap, which would
    // fight with the tap's own click.
    target.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'touch') {
        this.isHovered = true;
        this.play('hover');
      }
    });
    target.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'touch') {
        this.isHovered = false;
        this.pauseIfIdle();
      }
    });
    target.addEventListener('focusin', () => {
      this.isFocused = true;
      this.play('hover');
    });
    target.addEventListener('focusout', event => {
      if (!target.contains(event.relatedTarget)) {
        this.isFocused = false;
        this.pauseIfIdle();
      }
    });
  }
  bindScroll() {
    const viewFactor = parseFloat(this.element.dataset.wistiaScroll) || 0.5;
    new IntersectionObserver(([entry]) => {
      if (entry.intersectionRatio >= viewFactor) {
        if (!this.userPaused) {
          this.play('scroll');
        }
      } else {
        this.pause('scroll');
      }
    }, {
      threshold: [0, viewFactor]
    }).observe(this.element);
  }

  // Wistia sets an inline `cursor: default` inside its shadow root and exposes
  // no ::part() hooks, so let the cursor set on <wistia-player> (see
  // _wistia.scss) through.
  inheritCursor() {
    const root = this.player.shadowRoot;
    if (!root) {
      return;
    }
    if (!VTSWistiaPlayer.cursorSheet) {
      VTSWistiaPlayer.cursorSheet = new CSSStyleSheet();
      VTSWistiaPlayer.cursorSheet.replaceSync('.w-vulcan-v2 { cursor: inherit !important; }');
    }
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, VTSWistiaPlayer.cursorSheet];
  }
  pauseIfIdle() {
    if (!this.isHovered && !this.isFocused) {
      this.pause('hover');
    }
  }

  /**
   * @param {string|null} source 'hover', 'scroll', or null for an explicit play.
   */
  play(source = null) {
    if (this.isPlaying()) {
      // An explicit play takes ownership so hover/scroll won't pause it.
      if (!source) {
        this.playSource = null;
      }
      return;
    }
    this.playing = true;
    this.playSource = source;
    if (!source) {
      this.userPaused = false;
    }
    this.ready.then(() => this.player.play());
  }

  /**
   * @param {string|null} source Only pauses if this source started playback;
   *                             null pauses regardless.
   */
  pause(source = null) {
    if (!this.isPlaying() || source && source !== this.playSource) {
      return;
    }
    this.playing = false;
    this.playSource = null;
    if (!source) {
      this.userPaused = true;
    }
    this.ready.then(() => this.player.pause());
  }
  toggle() {
    if (this.isPlaying()) {
      this.pause();
    } else {
      this.play();
    }
  }

  // Uses our own state rather than `player.paused`, which is undefined
  // before the element upgrades and false in Wistia's "beforeplay" state.
  isPlaying() {
    return this.playing;
  }
  getTriggers() {
    return document.querySelectorAll(`[data-wistia-control][aria-controls="${CSS.escape(this.player.id)}"]`);
  }
  setState(state) {
    this.element.dataset.state = state;
    this.getTriggers().forEach(trigger => {
      trigger.dataset.state = state;
      const label = state === 'playing' ? trigger.dataset.labelPause : trigger.dataset.labelPlay;
      if (label) {
        trigger.setAttribute('aria-label', label);
      }
    });
  }
}
document.querySelectorAll('.wistia-player-component').forEach(element => new VTSWistiaPlayer(element));

// Delegated so triggers anywhere on the page (or added later) work.
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-wistia-control]');
  const instance = trigger && VTSWistiaPlayer.instances.get(trigger.getAttribute('aria-controls'));
  if (!instance) {
    return;
  }
  event.preventDefault();
  const action = trigger.dataset.wistiaControl;
  if (action === 'play') {
    instance.play();
  } else if (action === 'pause') {
    instance.pause();
  } else {
    instance.toggle();
  }
});
